import { store, persistor } from "../redux/store";
import { resetAuth } from "../redux/slices/authSlice";

/**
 * Global logout helper for the web app (micro-web).
 * - Clears persisted Redux auth/general state
 * - Clears the legacy "token" from localStorage
 * - Redirects to the sign-in route so all roles and routes are reset
 */
export function performLogout() {
  try {
    // Wipe persisted Redux state (whitelisted slices in persistConfig)
    persistor.purge();
  } catch (e) {
    // non-fatal
  }

  try {
    store.dispatch(resetAuth());
  } catch (e) {
    // non-fatal
  }

  try {
    localStorage.removeItem("token");
  } catch (e) {
    // non-fatal
  }

  // Hard redirect so all React state & routes reset to login
  window.location.href = "/authentication/sign-in";
}

